<template>
  <form
    v-if="isFooter"
    class="footer-subscribe" @submit.prevent="subscribe">
    <div class="footer-subscribe__in">
      <h4 :class="{error: errorExist}">{{ subscribeLabel }}</h4>
      <div class="footer-subscribe__form">
        <input v-model="email" :placeholder="emailPlaceholder" class="footer-subscribe__input" name="#"
               type="email">
        <button :class="{'is-disabled': !isAgree}" :disabled="!isAgree" class="footer-subscribe__btn"
                type="submit">
          <svg class="icon icon-arrow-right-long">
            <use xlink:href="#icon-arrow-right-long"
                 xmlns:xlink="http://www.w3.org/1999/xlink"></use>
          </svg>
        </button>
      </div>
    </div>
    <div class="footer-subscribe__checkbox">
      <input :id="`styled-checkbox-${id}`" v-model="isAgree" class="inp-group__checkbox" type="checkbox">
      <label :for="`styled-checkbox-${id}`">
        <span class="checkbox"></span>
        <span>{{ trans.text.footer.iHaveRead }} <a
          :href="`/${lang}/page/data-protection-basic-information-subscribe`"
          target="_blank">{{ trans.text.footer.privacyPolicy }}</a> {{ trans.text.footer.clause }}</span>
      </label>
    </div>
  </form>
  <form
    v-else
    @submit.prevent="subscribe"
    class="mb-form">
    <p :class="{error: errorExist}" class="mb-form__title">{{ subscribeLabel }}</p>
    <div class="mb-form-field">
      <input
        v-model="email"
        placeholder="Enter your e-mail"
        class="mb-form__input"
        name="#"
        type="email">
      <button
        :class="{'is-disabled': !isAgree}" :disabled="!isAgree"
        class="mb-form__btn"
        type="submit">
      </button>
    </div>
    <div class="mb-form__checkbox">
      <input
        :id="`styled-checkbox-${id}`"
        v-model="isAgree"
        class="inp-group__checkbox"
        type="checkbox">
      <label :for="`styled-checkbox-${id}`">
        <span class="checkbox"></span>
        <span>{{ trans.text.footer.iHaveRead }}
          <a :href="`/${lang}/page/data-protection-basic-information-subscribe`" target="_blank">{{ trans.text.footer.privacyPolicy }}</a>
          {{ trans.text.footer.clause }}
        </span>
      </label>
    </div>
  </form>
</template>

<script>
export default {
  props: ['lang', 'trans', 'id', 'isFooter', 'tags'],
  name: "SubscribeComponent",
  data() {
    return {
      email: null,
      customMessage: null,
      success: null,
      failed: null,
      isAgree: false,
      subscribeLabelDefault: 'Join our newsletter'
    }
  },
  computed: {
    subscribeLabel() {
      return this.customMessage ? this.customMessage : this.subscribeLabelDefault;
    },
    emailPlaceholder() {
      return this.trans.text.footer.emailPlaceholder
    },
    errorExist() {
      return this.failed === true;
    },
  },
  methods: {
    subscribe() {
      let ctx = this;
      let url = this.$path + `/subscribers`;
      axios.post(url, {email: this.email, lang: ctx.lang, tags: ctx.tags || []}).then(response => {
        ctx.email = null;
        ctx.success = true;
        ctx.failed = null;
        ctx.customMessage = response.data.message;
        setTimeout(function () {
          ctx.customMessage = null
          ctx.success = null;
          ctx.failed = null;
        }, 5000);
      }).catch(error => {
        ctx.success = null;
        ctx.failed = true;
        if (error.response && error.response.status === 403) {
          ctx.customMessage = error.response.data.message;
        } else {
          ctx.customMessage = 'Something went wrong, please try later';
        }
        setTimeout(function () {
          ctx.customMessage = null
          ctx.success = null;
          ctx.failed = null;
        }, 5000);
      })
    },
  },
  mounted() {
    this.subscribeLabelDefault = this.trans.text.footer.join
  }
}
</script>

<style lang="scss" scoped>
.is-disabled {
  &:hover {
    cursor: not-allowed;
  }
}
</style>
